<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import RecipientList from './RecipientList'
import Popup from './Popup'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Notifikasi',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Popup,
    RecipientList,
    McButton,
  },
  computed: {
    title() {
      return this.$t('notification.object.notificationSetting')
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    items() {
      return [
        {
          to: '/notification',
          text: this.$t('global.object.notification'),
        },
        {
          text: this.$t('notification.object.notificationSetting'),
        },
      ]
    },
  },
  mounted() {
    this.$store.commit('notification/SET_STATUS', 'Popup')
  },
  methods: {
    save() {
      this.currentTab = this.$refs.tabs.currentTab
      if (this.currentTab == 0) {
        this.$refs.popup.toSave()
      }
    },
    handleBack() {
      if (this.hasAccess(['e1j-log-notification:read'])) {
        this.$router.push({ name: 'Notification Log' })
      } else {
        this.$router.push({ name: 'Notifikasi' })
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader
      v-if="false"
      :title="title"
      :items="items"
      class="mc-page-three"
      :routeBack="'/notification'"
      hasBackButton
      hasBreadcrumb
    />

    <PageHeader
      :title="title"
      class="mc-page-three"
      :subTitle="$t('notification.text.settingNotification')"
    >
      <template #afterTitle>
        <McButton
          variant="secondary"
          :icon="'icon-outline_arrow-left'"
          :text="$t('global.back')"
          @click="handleBack"
        />
      </template>
    </PageHeader>

    <form>
      <b-card class="mc-card__setting">
        <b-tabs ref="tabs" content-class="p-3 text-muted">
          <Popup
            v-if="hasAccessAll(['e2a-popup-notifikasi:create', 'e2a-popup-notifikasi:read'])"
            ref="popup"
            status="Popup"
          />
          <RecipientList
            v-if="
              hasAccessAll([
                'e3a-email-notifikasi:read',
                'e3a-email-notifikasi:delete',
                'vgroups:read',
              ])
            "
            ref="delivery"
            status="RecipientList"
          />
        </b-tabs>
      </b-card>
    </form>
  </Layout>
</template>
